import React from 'react'
import cn from 'classnames'

import styles from './app.module.css'

function FilterItem({ item, queryItems, onClick }) {
  return (
    <li
      className={cn(
        styles.tracksFilterItem,
        styles.tracksButton,
        styles.tracksFilterSelectionItems,
        {
          [styles.active]: queryItems && queryItems.includes(item),
        }
      )}
      key={item}
      onClick={onClick}
    >
      <div className={styles.tracksFilterItemText}>{item}</div>
    </li>
  )
}

export default FilterItem
